/**************************************** zmf 重构开发 执行公共工具跳转工具类 ******************************************/

/***
 * 打开主页 支持公共函数
 * *
 *export const openHomePage = (context, goMyCenter) => {
 *	let page = '/content';
 *	if(goMyCenter) {
 *		page = '/mycenter';
 *	}
 *	context.$router.replace(page);
 * }
 *
 * 条件：openAudio(this,this.$refs.staudio,"https://m801.music.126.net/20200227152347/2e1c062c7544106c05d0da847d8914f6/jdyyaac/5258/060e/0153/e26f139b621daa5a3eee69732a8cfabb.m4a");
 *
 * 引入：import {openAudio} from '@pageRouter/funRouter'
 * */

/**
 * 打开音视频接口
 */
export const openAudio = (content,el,id, Url) =>{
	if(!el){
		weui.alert("播放音频文件，参数错误");
		return;
	}
	el.playAudioNew(id, Url);
};

/**
 *
 * @param content
 * @param el 引入对应audio。vue
 * @param Url
 */
export const openVidio = (content,el, id,Url) =>{
	if(!el){
		weui.alert("播放视频文件，参数错误");
		return;
	}
	el.play(id, Url);
};

/*
* item : item.id  item.sec   item.attachFileName item.fileSize
* */
export const numberFileSize = (fileSize) => {
	if(!fileSize){
		return '';
	}
	var tail = 'b';
	if(fileSize > 1000){
		fileSize = (fileSize/1000).toFixed(1);
		tail = 'KB'
	}
	if(fileSize > 1000){
		fileSize = (fileSize/1000).toFixed(1);
		tail = 'MB'
	}
	return fileSize + tail;
};






// WEBPACK FOOTER //
// ./src/components/pageRouter/funRouter.js